var exports = {
  "X": "BetaLabel__fqv2CX",
};

module.exports = exports;
